export const HAS_OPTED_INTO_BIOMETRICS = 'has-opted-into-biometrics';
export const HAS_SUCCESSFULLY_LOGGED_IN = 'has-successfully-logged-in';
export const HAS_SETUP_PIN = 'has-set-up-pin-login';
export const USER_PIN = 'user-pin';
export const HAS_OPTED_INTO_BIOMETRICS_AND_PIN =
  'has-opted-into-biometrics-and-pin';
export const HAS_SUCCESSFULLY_SETUP_PIN_AND_BIOMETRICS =
  'has-successfully-setup-pin-and-biometrics';
export const SHOW_SUCCESS_MODAL = 'show-success-modal';
export const APP_FIRST_LAUNCH = 'app-first-launch';
export const BIOMETRIC_REQUESTED = 'biometric_requested';
